import { Component, OnInit, Input } from "@angular/core";
import { BlogSlider } from "../../../shared/data/slider";
import { AngularFirestore } from "@angular/fire/compat/firestore";

@Component({
  selector: "app-blog",
  templateUrl: "./blog.component.html",
  styleUrls: ["./blog.component.scss"],
})
export class BlogComponent implements OnInit {
  blogs: any[] = [];
  carouselOptions = {
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      992: {
        items: 3,
      },
    },
  };
  constructor(private fire: AngularFirestore) {}

  ngOnInit(): void {
    this.getProducts();
  }

  getProducts() {
    this.fire
      .collection("Blogs", (ref) => ref.limit(6))
      .valueChanges()
      .subscribe(
        (res) => {
          this.blogs = res;
        },
        (err) => {
          console.log(err, "error");
        }
      );
  }

  // public BlogSliderConfig: any = BlogSlider;
}
